import React, { Component } from 'react'

export default class Error extends Component {

  render () {  	
    return (
	      <div>
	      	<p>Errorrrrrr</p>
      	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Maps/error.js